/**
 * Maps server-generated CSS class name strings (from CssClassNames.cs)
 * to Tailwind utility classes for use in the GRC grid.
 *
 * The API embeds class name strings in the response (e.g. DayDetailDto.TotalBlockedCountCss).
 * This utility converts them so the React UI never applies arbitrary class strings.
 */

const CSS_MAP: Record<string, string> = {
  // Room capacity exceeded → red bg white text; within limits → black bg white text
  "grc-total-blocked-count_red": "bg-[#9A1212] text-white font-semibold",
  "grc-total-blocked-count_black": "bg-black text-white font-semibold",

  // Available-to-sell: negative → dark red bg; zero or positive → gray bg
  "grc-availabletosell_red": "bg-[#9A1212] text-white font-semibold",
  "grc-availabletosell_gray": "bg-[#A7A8AA] text-black font-semibold",

  // SoftHold cell states (exact from grcgridcss.css – semi-transparent overlays)
  "grc-softhold-unchecked": "opacity-30",
  "grc-softhold-preferreddates": "bg-[#FFD00026]",
  "grc-softhold-overbooking":    "bg-[#DA291C26]",

  // ── Column header & cell backgrounds (exact hex from app.css) ─────────────
  "bg-default-header": "bg-[#E8E8E8]",

  // US Holidays – solid header, semi-transparent cells
  "bg-US-holiday-header": "bg-[#C9D9E9]",
  "bg-US-holiday":        "bg-[#C9D9E940]",
  "USHolidaysHeaderCss":  "bg-[#C9D9E9]",
  "USHolidaysCss":        "bg-[#C9D9E980]",

  // Deloitte days – solid header, semi-transparent cells
  "bg-deloitte-day-header":    "bg-[#A2C593]",
  "bg-deloitte-day":           "bg-[#A2C59326]",
  "DeloitteHolidaysHeaderCss": "bg-[#A2C593]",
  "DeloitteHolidaysCss":       "bg-[#A2C59380]",

  // Do Not Block days (gray)
  "DoNotBlockHolidaysHeaderCss": "bg-[#8B8B8B]",
  "DoNotBlockHolidaysCss":       "bg-[#8B8B8B80]",

  // Religious Holidays (purple)
  "ReligiousHolidaysHeaderCss": "bg-[#CCC0DE]",
  "ReligiousHolidaysCss":       "bg-[#CCC0DE80]",

  // ── Event status indicator dot colours (exact from app.css) ───────────────
  "event-status-definite":        "bg-[#43B02A]",
  "event-status-tentative":       "bg-[#FFCD00]",
  "event-status-prospect":        "bg-[#63666A]",
  "event-status-softhold":        "bg-[#62B5E5]",
  "event-status-draft":           "bg-[#9368B7]",
  "event-status-draft-Core":      "bg-[#9368B7]",
  "event-status-draft-Secondary": "bg-[#D1BCE3]",
};

/** Converts a server-sent CSS class string to Tailwind classes. Falls back gracefully. */
export function grcCss(serverClass: string | null | undefined): string {
  if (!serverClass) return "";
  return CSS_MAP[serverClass] ?? "";
}
